import { memo } from 'react';
import { Alert, Box, Button, SpaceBetween, TextContent } from '@amzn/awsui-components-core';

import { usePublisherReviewStageViewModel } from './AuthorPublisherReviewStatePanelViewModel';
import { SaveErrorAlert } from './SaveErrorAlert';
import PanelSection from './PanelSection';
import ScanFindingsTable from './ScanFindingsTable';
import { PanelDivider } from './PanelDivider';

export const AuthorPublisherReviewStatePanel = memo(function AuthorPublisherReviewStatePanel() {
  const vm = usePublisherReviewStageViewModel();

  if (vm.isScanning) {
    return (
      <SpaceBetween size="m" direction="vertical" alignItems="center">
        <Box color="text-body-secondary">Scanning your content for quality issues…</Box>
      </SpaceBetween>
    );
  }

  return (
    <SpaceBetween size="m" direction="vertical">
      <ScanFindingsTable scannerFindings={vm.scannerFindings} isLoading={vm.isLoadingFindings} />

      {vm.scanWarningMessage && (
        <Alert type="warning" header="Content flagged">
          {vm.scanWarningMessage}
        </Alert>
      )}

      <PanelDivider />

      <PanelSection title="Required to proceed">
        <TextContent>
          <ul>
            {vm.requirementsToProceed.map((requirement) => (
              <li key={requirement}>{requirement}</li>
            ))}
          </ul>
        </TextContent>
      </PanelSection>

      {vm.errorMessage && (
        <SaveErrorAlert
          errorMessage={vm.errorMessage}
          validationIssues={vm.validationIssues}
          onDismiss={vm.dismissError}
        />
      )}

      <SpaceBetween size="xs" direction="vertical">
        {vm.subState === 'rejected' && (
          <Button
            variant="primary"
            fullWidth
            disabled={vm.isBusy}
            loading={vm.isResubmitLoading}
            onClick={vm.resubmitForReview}
          >
            Resubmit for review
          </Button>
        )}
        <Button
          variant="link"
          fullWidth
          disabled={vm.isBusy}
          loading={vm.isSaveLoading}
          onClick={vm.saveAndClose}
        >
          Save and close
        </Button>
      </SpaceBetween>
    </SpaceBetween>
  );
});
